import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  MenuItem,
  Alert,
  Fade,
} from '@mui/material';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

function RegisterPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    role: 'student',
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const res = await fetch('http://196.216.9.34:5020/api/auth/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (res.ok) {
      alert('Registration successful! You can now log in.');
      navigate('/login');
    } else {
      setError(data.message || 'Registration failed');
    }
  };

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>
      {/* Animated Background */}
      <Box
        component="video"
        src="mbs building.mp4" // replace with your actual video path
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'fixed',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      />

      {/* Overlay Tint */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1,
        }}
      />

      {/* Layout */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          height: '100vh',
        }}
      >
        {/* Left Logo */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              width: 500,
              height: 500,
              backgroundImage: "url('/logos/standardsLogo.png')",
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              opacity: 0,
              animation: 'logoFadeIn 2s ease-out forwards',
              '@keyframes logoFadeIn': {
                '0%': {
                  transform: 'scale(1.4)',
                  filter: 'blur(12px)',
                  opacity: 0,
                },
                '100%': {
                  transform: 'scale(1)',
                  filter: 'blur(0)',
                  opacity: 1,
                },
              },
            }}
          />
        </Box>

        {/* Right Form */}
        <Fade in timeout={600}>
          <Paper
            elevation={12}
            sx={{
              width: 380,
              height: '100vh',
              borderRadius: 0,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              px: 4,
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              overflow: 'auto',
            }}
          >
            <Box textAlign="center" mb={3}>
              <PersonAddAltIcon sx={{ fontSize: 50, color: '#ff6600', mb: 1 }} />
              <Typography variant="h5" fontWeight="bold">
                Create Account
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Join the learning community
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <TextField
                label="Username"
                name="username"
                fullWidth
                margin="normal"
                value={formData.username}
                onChange={handleChange}
                required
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                margin="normal"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <TextField
                label="Password"
                name="password"
                type="password"
                fullWidth
                margin="normal"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <TextField
                label="Role"
                name="role"
                select
                fullWidth
                margin="normal"
                value={formData.role}
                onChange={handleChange}
              >
                <MenuItem value="student">Participant</MenuItem>
                {/* <MenuItem value="instructor">Instructor</MenuItem> */}
              </TextField>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{ mt: 2, py: 1.5, backgroundColor: '#ff6600' }}
              >
                Register
              </Button>
            </form>

            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Already have an account?{' '}
              <span
                onClick={() => navigate('/login')}
                style={{
                  color: '#ff6600',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                }}
              >
                Log in
              </span>
            </Typography>
          </Paper>
        </Fade>
      </Box>
    </Box>
  );
}

export default RegisterPage;
